import { Menu, MenuItem } from "@mui/material";
import styles from "./m3.module.css";

/**
 * Menu with M3 styling, shared by SplitButton and OverflowMenu.
 * Items: { key, label, description?, icon?, onClick, disabled?, danger?, divider?, hidden? }
 */
const M3Menu = ({ anchorEl, open, onClose, items = [], anchorOrigin, transformOrigin }) => (
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    anchorOrigin={anchorOrigin || { vertical: "bottom", horizontal: "right" }}
    transformOrigin={transformOrigin || { vertical: "top", horizontal: "right" }}
    slotProps={{ paper: { className: styles.menuPaper, elevation: 0 }, list: { disablePadding: true } }}
  >
    {items
      .filter((item) => item && !item.hidden)
      .map((item, i) =>
        item.divider ? (
          <div key={item.key || `divider-${i}`} className={styles.menuDivider} role="separator" />
        ) : (
          <MenuItem
            key={item.key || item.label}
            className={`${styles.menuItem} ${item.danger ? styles.menuItemDanger : ""}`}
            disabled={item.disabled}
            onClick={() => {
              onClose();
              if (item.onClick) item.onClick();
            }}
          >
            {item.icon && <span className={styles.menuItemIcon}>{item.icon}</span>}
            <span className={styles.menuItemText}>
              <span className={styles.menuItemLabel}>{item.label}</span>
              {item.description && <span className={styles.menuItemDesc}>{item.description}</span>}
            </span>
          </MenuItem>
        ),
      )}
  </Menu>
);

export default M3Menu;
